module.exports = __webpack_public_path__ + "img/inst-modal-5.d671215e.png";